import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation, Link } from 'react-router-dom';

import { DateFormatter } from "../../utils/DateFormatter";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';


export default function ConfigValues() {
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const [configKeyData, setConfigKeyData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [globalFilterValue, setGlobalFilterValue] = useState('');


    const navigate = useNavigate(); 


    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };

    const [userDetails, setUserDetails] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('userDetails', null)
    );

    const canView = (userDetails) => {
        if (userDetails) {
            return userDetails.permissions.some(e => e.codename === 'view_workflowconfigmanagement');
        }
        return false;
    }

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    
      }

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    const dateTemplate = (configkey) => {
        return DateFormatter(configkey.createdAt);
    }


    useEffect(() => {
        document.title = `ConfigKeys | Palmona Pathogenomics`
    }, []);


    useEffect(() => {


        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue`, {
            headers,
            }).then((res) => res.json())
            .then(data => {
                // console.log('workflow data', data);
                setConfigKeyData(data);
            }
            ).catch((error) => {
                console.log('Error in getting ConfigValues', error);
            });

        

        setLoading(false);
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps


    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        ConfigKeyId: { value: null, matchMode: FilterMatchMode.EQUALS },
        value: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        DisplayValue: { value: null, matchMode: FilterMatchMode.EQUALS },
        createdAt: { value: null, matchMode: FilterMatchMode.EQUALS }
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };


    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </span>
            </div>
        );
    };


    const header = renderHeader();

    const configvalueBodyTemplate = (configValue) => {

        return (
            <div>
                <Link to={`/workflows/configvalue/${configValue.id}`} className="ml-2">{configValue.id}</Link>
            </div>
        );
    };

    const configvkeyBodyTemplate = (configValue) => {

        return (
            <div>
                <Link to={`/workflows/config/${configValue.ConfigKeyId}`} className="ml-2">{configValue.ConfigKeyId}</Link>
            </div>
        );
    };

    return (
        <>
        { canView(userDetails) && 
            <div className="datasets-main">
                <div className="d-flex justify-content-between">
                    <DataTable 
                        value={configKeyData} 
                        responsiveLayout="scroll" 
                        stripedRows 
                        paginator 
                        rows={25} 
                        rowsPerPageOptions={[25, 50, 75, 100]} 
                        removableSort
                        emptyMessage="No ConfigValues found."
                        filters={filters} 
                        filterDisplay="row" 
                        loading={loading}
                        globalFilterFields={['id', 'ConfigKeyId', 'value', 'DisplayKey', 'createdAt', 'updatedAt']}
                        header={header}
                    >
                        <Column field="id" header="ConfigValue ID" body={configvalueBodyTemplate} sortable filter filterPlaceholder=""></Column>
                        <Column field="ConfigKeyId" header="ConfigKeyId" body={configvkeyBodyTemplate} sortable filter filterPlaceholder=""></Column>
                        <Column field="value" header="Value" sortable filter filterPlaceholder=""></Column>
                        <Column field="DisplayValue" header="DisplayValue" sortable filter filterPlaceholder=""></Column>
                        <Column field="createdAt" header="Date Created" body={dateTemplate} sortable filter filterPlaceholder=""></Column>
                        <Column field="updatedAt" header="Date Updated" body={dateTemplate}></Column>
                    </DataTable>
                </div>
                <br />
            </div>
        }

        { !canView(userDetails) && <div className="font-medium text-3xl text-900 mb-3">You do not have permission to view this page.</div> }
        </>
    );
}
